import { useAppSelector } from 'src/app/hooks';
import ElementWithModal from 'src/components/common/vx/element-with-modal/ElementWithModal';

export default function OnlineCheck() {
  const isOnline = useAppSelector((state) => state.devSlice.isOnline);

  return isOnline ? (
    <></>
  ) : (
    <ElementWithModal
      open={true}
      withReload={true}
      element={<></>}
      header={
        <div>
          <i className="fa-solid fa-triangle-exclamation fa-lg text-warning" />
          <span className={'ms-2 fs-5 fw-bold'}>Warning</span>
        </div>
      }
      modalContent={
        <div className={'text-center'}>
          <div className={'fw-bold fs-5'}>No Internet</div>
          Check your connection and try again.
        </div>
      }
    />
  );
}
